/**
 * RESPONSIBILITY: the best still YouTube actually has for one video.
 *
 * `maxresdefault` (1280×720) first, since it is what a full-width band wants; `hqdefault`
 * (480×360) always exists and is the fallback when it does not. Only the browser can tell
 * them apart — YouTube serves a 120×90 grey image for a maxres still that is missing
 * rather than a 404, and it is `naturalWidth` on load, not an error, that gives it away.
 */
import { useState } from 'react';
import { youtubeThumbs } from './youtube';

export function YoutubeThumb({
  url, alt, className = '',
}: {
  url: string | undefined;
  alt: string;
  className?: string;
}) {
  const thumbs = youtubeThumbs(url);
  const [step, setStep] = useState(0);

  if (step >= thumbs.length) return null;

  return (
    <img
      className={`pic ${className}`}
      src={thumbs[step]}
      alt={alt}
      loading="lazy"
      onError={() => setStep(step + 1)}
      onLoad={(e) => { if (e.currentTarget.naturalWidth <= 120) setStep(step + 1); }}
    />
  );
}
